module.exports = __webpack_public_path__ + "static/media/Maf_banners_servicios_sectori industrias.27c32341.jpg";